import React, { useState } from "react";
import { MessageCircle, MessageCircleOff, Check } from "lucide-react";
import api from "../lib/api";
import { useTipUnseen } from "./CoachTip";

// Builder: comment-icon checkbox on a section (off by default).
export const SectionCommentToggle = ({ s, ensureKey, onSaved, highlight }) => {
  const [busy, setBusy] = useState(false);
  const glow = useTipUnseen("beacon-comments") && highlight;
  const flip = async () => {
    setBusy(true);
    try {
      if (!s.comments && !(await ensureKey())) { window.alert("Unlock your vault first, comments are encrypted with your Beacon key."); return; }
      await api.patch(`/beacon/mine/sections/${s.id}`, { comments: !s.comments });
      await onSaved();
    } catch { window.alert("Couldn't save, please try again."); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={flip} disabled={busy} aria-pressed={!!s.comments} data-testid={`beacon-section-comments-${s.id}`}
      title={s.comments ? "Comments on for lessons in this section: tap to turn off" : "Turn on comments for lessons in this section"}
      className={`flex items-center gap-1 px-1.5 py-1 rounded transition-colors disabled:opacity-40 ${s.comments ? "text-[#14A89A]" : "text-zinc-500 hover:text-white"} ${glow ? "ring-2 ring-[#14A89A] animate-pulse text-[#14A89A]" : ""}`}>
      <MessageCircle size={15} />
      <span className={`w-3.5 h-3.5 border flex items-center justify-center ${s.comments ? "bg-[#14A89A] border-[#14A89A]" : "border-zinc-600"}`}>{s.comments && <Check size={10} className="text-[#0A0A0A]" strokeWidth={3} />}</span>
    </button>
  );
};

// Builder: per-lesson switch, only shown when its section has comments on.
export const ItemCommentToggle = ({ it, onSaved }) => {
  const off = !!it.comments_off;
  const flip = async () => {
    try { await api.patch(`/beacon/mine/items/${it.id}`, { comments_off: !off }); await onSaved(); } catch { window.alert("Couldn't save, please try again."); }
  };
  const Icon = off ? MessageCircleOff : MessageCircle;
  return (
    <button type="button" onClick={flip} aria-pressed={!off} data-testid={`beacon-item-comments-${it.id}`}
      title={off ? "Comments off for this lesson: tap to turn on" : "Comments on: tap to turn off for this lesson"}
      className={off ? "text-zinc-600 hover:text-white" : "text-[#14A89A] hover:brightness-125"}>
      <Icon size={13} />
    </button>
  );
};
